import React, { useState, useEffect } from "react";
import "./login.css";
import loginbg from "../../typography/img/Login.jpg";
import Logo from "../../typography/img/logo.png";
import ForgetPasswordForm from "./ForgetPassword";
import Modal from "./Modal";
import $ from "jquery";
import { useAuth } from "../Context/AuthProvider";

const LoginForm = ({ showModalOnLoad }) => {
  const { loginAction } = useAuth();
  const [emailId, setEmailId] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [showForgetPasswordForm, setShowForgetPasswordForm] = useState(false);
  const [showModal, setShowModal] = useState(showModalOnLoad);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [validEmail, setValidEmail] = useState(true);

  const validateEmailFormat = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleForgetPasswordClick = () => {
    setShowForgetPasswordForm(true);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async () => {
    let formData = new FormData();
    formData = { username: emailId, password: password };

    var result = await loginAction(formData);

    if (result) {
      if (rememberMe) {
        localStorage.setItem("email", emailId);
        localStorage.setItem("password", password);
      } else {
        localStorage.removeItem("email");
        localStorage.removeItem("password");
      }

      console.log(result);
      window.location.reload();
    } else {
      alert("*__Please enter valid email & password__*");
    }
  };

  const handleModalSubmit = () => {
    if (newPassword !== confirmPassword) {
      alert("New password and confirm password must match.");
      return;
    }

    setPassword(newPassword);
    handleSubmit();

    setNewPassword("");
    setConfirmPassword("");
    setShowModal(false);
  };

  useEffect(() => {
    const handleToggleClick = (e) => {
      const passwordInput = $("#passwordInput");
      e.preventDefault();
      if (passwordInput.attr("type") === "text") {
        passwordInput.attr("type", "password");
        $(e.currentTarget).find("i").toggleClass("bi-eye bi-eye-slash");
      } else {
        passwordInput.attr("type", "text");
        $(e.currentTarget).find("i").toggleClass("bi-eye bi-eye-slash");
      }
    };

    $("#togglePasswordVisibility").on("click", handleToggleClick);

    return () => {
      $("#togglePasswordVisibility").off("click", handleToggleClick);
    };
  }, []);

  const validateAndSubmitModal = () => {
    if (!validateEmailFormat(emailId)) {
      setValidEmail(false);
      return;
    }

    handleModalSubmit();
  };

  return (
    <div className="login_box">
      <div className="row g-0">
        <div className="col-lg-7 col-xl-8 d-none d-lg-block bg-login">
          <img src={loginbg} width="100%" alt="" />
        </div>
        <div className="col-lg-5 col-xl-4">
          <div className="login_form px-5 py-4">
            <div className="logo_login">
              <img src={Logo} className="img-fluid" alt="" />
            </div>
            <div className="form_area">
              <h3 className="fs-24 lh-34 fw-600 mt-4">Nice to see you again</h3>
              {showForgetPasswordForm ? (
                <ForgetPasswordForm
                  setShowForgetPasswordForm={setShowForgetPasswordForm}
                />
              ) : (
                <form>
                  <div className="form-group mt-4 mb-3 position-relative">
                    <label htmlFor="" className="fs-14 lh-15 mb-2 ps-3 d-block">
                      Login
                    </label>
                    <input
                      type="email"
                      className={`form-control ${validEmail ? "" : "is-invalid"
                        }`}
                      placeholder="Email or phone number"
                      value={emailId}
                      autoComplete="off"
                      onChange={(event) => {
                        setEmailId(event.target.value);
                        setValidEmail(true); // Reset email validation state on change
                      }}
                    />
                    {!validEmail && (
                      <div className="invalid-feedback">
                        Please enter a valid email address.
                      </div>
                    )}
                  </div>
                  <div className="form-group mt-4 mb-3 position-relative">
                    <label htmlFor="" className="fs-14 lh-15 mb-2 ps-3 d-block">
                      Password
                    </label>
                    <div className="input-group">
                      <input
                        type={showPassword ? "text" : "password"}
                        id="passwordInput"
                        className="form-control"
                        placeholder="Enter password"
                        value={password}
                        autoComplete="off"
                        onChange={(event) => setPassword(event.target.value)}
                        style={{
                          borderTopRightRadius: "10px",
                          borderBottomRightRadius: "10px",
                        }}
                      />
                      <button
                        type="button"
                        id="togglePasswordVisibility"
                        className="color-4D border-0 bg-none"
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                        }}
                      >
                        <i
                          className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"
                            }`}
                          style={{ fontSize: "1.2rem" }}
                        ></i>
                      </button>
                    </div>
                  </div>
                  <div className="form-check mb-3">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="rememberMe"
                      checked={rememberMe}
                      onChange={() => setRememberMe(!rememberMe)}
                    />
                    <label className="form-check-label" htmlFor="rememberMe">
                      Remember Me
                    </label>
                  </div>
                  <div className="text-end">
                    <a
                      href="#"
                      className="fs-14 lh-24 "
                      onClick={() => handleForgetPasswordClick()}
                    >
                      Forgot password?
                    </a>
                  </div>
                  <button
                    type="button"
                    className="btn btn-success w-100 mt-3 mb-2"
                    onClick={() => handleSubmit()}
                  >
                    Sign in
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal show={showModal} onClose={() => setShowModal(false)}>
        <h6 className="text-center">
          <b>Reset Password</b>
        </h6>

        <div className="form-group">
          <label>Email ID</label>
          <input
            type="email"
            className={`form-control ${validEmail ? "" : "is-invalid"}`}
            value={emailId}
            onChange={(e) => {
              setEmailId(e.target.value);
              setValidEmail(true);
            }}
            style={{ borderRadius: "5px", height: "30px", width: "100%" }}
          />
          {!validEmail && (
            <div className="invalid-feedback">
              Please enter a valid email address.
            </div>
          )}
        </div>
        <div className="form-group">
          <label>New Password</label>
          <div className="input-group">
            <input
              type={showPassword ? "text" : "password"}
              className="form-control"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              style={{ borderRadius: "5px", height: "30px", width: "100%" }}
            />
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={togglePasswordVisibility}
              style={{
                height: "38px",
                border: "none",
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                borderRadius: "0",
              }}
            >
              <i
                className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}
                style={{ fontSize: "1.2rem" }}
              ></i>
            </button>
          </div>
        </div>
        <div className="form-group">
          <label>Confirm Password</label>
          <div className="input-group">
            <input
              type={showPassword ? "text" : "password"}
              className="form-control"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              style={{ borderRadius: "5px", height: "30px", width: "100%" }}
            />
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={togglePasswordVisibility}
              style={{
                height: "38px",
                border: "none",
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                borderRadius: "0",
              }}
            >
              <i
                className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}
                style={{ fontSize: "1.2rem" }}
              ></i>
            </button>
          </div>
        </div>
        <div className="text-center mt-4">
          <button
            type="button"
            className="btn btn-success btn-small"
            onClick={validateAndSubmitModal}
          >
            Reset Password
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default LoginForm;
